import { Divider } from 'antd';
import styled from 'styled-components';

export const ContainerForm = styled.div`
    margin: 0px 30px;
`

export const ContainerSchedule = styled.div`
    padding-bottom: 25px;
    
`;

export const TextDivider = styled.span`
    font-size: 16px;
    font-weight: 500;
`

export const TextSchedule = styled.div`
    flex: 1;
    flex-direction: row;
`;

export const AntdDivider = styled(Divider)`
    @media (max-width: 400px) {
        white-space: unset !important;
    }
`;